import React, { Component } from 'react'
import { FormattedMessage, injectIntl, intlShape, FormattedHTMLMessage } from 'react-intl'

import { callApi } from '../services/fetchService'

import FaIcon from '../components/FaIcon'

import { Button, Form, Input, message } from 'antd'
const FormItem = Form.Item
const { TextArea } = Input

class Contact extends Component {

    static propTypes = {
        intl: intlShape.isRequired
    }

    state = {
        sending: false
    }
    
    handleSubmit = (e) => {
        const { intl, form } = this.props
        e.preventDefault();
        form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.setState({sending: true})
                callApi({
                    endpoint: 'messages',
                    method: 'PUT',
                    body: values
                }).then((data) => {
                    message.success(intl.formatMessage({id: "contact.messageSent"}))
                    this.setState({sending: false})
                    form.resetFields();
                }).catch((data) => {
                    message.error(intl.formatMessage({id: 'misc.unknownError'}))
                    this.setState({sending: false})
                })
            }
        })
    }

    /**
     * Render view
     */
    render() {
        const { intl } = this.props
        const { getFieldDecorator } = this.props.form
        const formItemLayout = {
            labelCol: { span: 4 },
            wrapperCol: { span: 20 },
            style: { marginBottom: '10px' }
        }
        const tailFormItemLayout = {
            wrapperCol: { offset: 4, span: 20 }
        }
        return (
            <div>
                <h1><FaIcon icon="envelope" fixedWidth /> <FormattedHTMLMessage id="contact.title" /></h1>
                <Form layout="horizontal" onSubmit={this.handleSubmit}>
                    <FormItem label={<FormattedMessage id="contact.titleField" />} {...formItemLayout}>
                        {getFieldDecorator('title', {
                            rules: [{required: true, message: intl.formatMessage({id: 'contact.titleRequired'})}]
                        })(<Input/>)}
                    </FormItem>
                    <FormItem label={<FormattedMessage id="contact.messageField" />} {...formItemLayout}>
                        {getFieldDecorator('message', {
                            rules: [{required: true, message: intl.formatMessage({id: 'contact.messageRequired'})}]
                        })(<TextArea autosize={{ minRows: 4, maxRows: 10 }} />)}
                    </FormItem>
                    <FormItem {...tailFormItemLayout}>
                        <Button type="primary" htmlType="submit" loading={this.state.sending}><FaIcon icon="paper-plane"/> <FormattedMessage id="contact.sendMessage" /></Button>
                    </FormItem>
                </Form>
            </div>
        )
    }

}

export default injectIntl(Form.create()(Contact))


// WEBPACK FOOTER //
// ./src/views/Contact.js